import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import { format, parseJSON } from "date-fns";
import { es } from "date-fns/locale";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ForumIcon from "@material-ui/icons/Forum";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import StoreIcon from "@material-ui/icons/Store";
import { API, graphqlOperation } from "aws-amplify";
import React, { useContext, useEffect, useState, useReducer } from "react";
import { PLANES } from "../constants";
import {
  formatCelular,
  formatRut,
  unformatRut,
  formatCuentaBancaria,
  toTitleCase,
  generateSlug,
  validateEmail,
  nombreEsValido,
  rutEsValido
} from "../functions";
import { updateStore } from "../graphql/mutations";
import logger from "../logger";
import { AppContext, fetchStore, defaultStore } from "../views/App";
import DeliveryServiceDetails from "./DeliveryServiceDetails";
import TabPanel from "./TabPanel";
import { PAYMENT_OPTIONS } from "./Ventas/constants";
import InfoIcon from "@material-ui/icons/Info";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import EditIcon from "@material-ui/icons/Edit";
import NumberFormat from "react-number-format";
import SelectAddress from "./SelectAddress";
import SelectBanco from "./SelectBanco";
import SelectTipoCuenta from "./SelectTipoCuenta";
import Hidden from "@material-ui/core/Hidden";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import MapIcon from "@material-ui/icons/Map";
import FaqList from "./FaqList";
import AlertTitle from "@material-ui/lab/AlertTitle";
import { checkSlugName } from "../views/App";
import { MobileContext } from "../views/app/Mobile";

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  container: {
    width: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2)
    },
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(0, 2),
      padding: theme.spacing(2, 0)
    }
  },
  card: {
    width: "100%",
    height: "100%"
  },
  cardHeader: {
    paddingBottom: 0
  },
  tabbar: {
    top: "56px",
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      top: "48px"
    },
    [theme.breakpoints.up("sm")]: {
      top: "64px"
    },
    backgroundColor: theme.palette.primary.light
  },
  tabpanel: {
    width: "100%"
  },
  bold: {
    fontWeight: "bold",
    color: theme.palette.text.secondary
  },
  whatsappForm: {
    margin: 0
  },
  loadingContainer: {
    height: "calc(100vh - 56px)",
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      height: "calc(100vh - 48px)"
    },
    [theme.breakpoints.up("sm")]: {
      height: "calc(100vh - 64px)"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  loading: {
    margin: theme.spacing(1)
  },
  panelcolumn: {
    height: "auto",
    [theme.breakpoints.up("sm")]: {
      height: "40vh"
    },
    overflow: "auto"
  },
  panellist: {
    backgroundColor: "#efefef"
  },
  proximamente: {
    display: "flex",
    flexDirection: "column",
    alignItems: "cente",
    justifyContent: "center",
    padding: theme.spacing(2, 6)
  },
  titleIcons: {
    color: theme.palette.text.secondary
  },
  addIcon: {
    fontSize: "3rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem"
    }
  },
  deliveryServicesList: {
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    marginBottom: theme.spacing(2)
  },
  deliveryServiceItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  saveButton: {
    width: 120,
    marginLeft: "auto"
  },
  pre: {
    whiteSpace: "pre-line"
  }
}));

const tabs = {
  general: { value: 0, label: "General" },
  tiposEntrega: { value: 1, label: "Tipos de entrega" },
  mediosPago: { value: 2, label: "Medios de pago" },
  comunidades: { value: 3, label: "Comunidades" },
  faq: { value: 4, label: "Preguntas Frecuentes" }
};

const initialState = {
  general: {
    general: {
      name: "",
      slug: "",
      description: ""
    },
    contacto: {
      email: "",
      phone: "",
      whatsapp: false
    },
    ubicacion: {
      address: null
    },
    bancarios: {
      titular: "",
      rut: "",
      cuenta: "",
      banco: null,
      tipoCuenta: null
    }
  }
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case "general":
      return { ...state, [type]: payload };
    case "general.general":
      return {
        ...state,
        general: {
          ...state.general,
          general: payload
        }
      };
    case "general.general.prop":
      return {
        ...state,
        general: {
          ...state.general,
          general: { ...state.general.general, [payload.prop]: payload.value }
        }
      };
    case "general.general.name":
      return {
        ...state,
        general: {
          ...state.general,
          general: {
            ...state.general.general,
            name: payload,
            slug: generateSlug(payload)
          }
        }
      };
    case "general.contacto":
      return {
        ...state,
        general: {
          ...state.general,
          contacto: payload
        }
      };
    case "general.contacto.prop":
      return {
        ...state,
        general: {
          ...state.general,
          contacto: { ...state.general.contacto, [payload.prop]: payload.value }
        }
      };
    case "general.ubicacion":
      return {
        ...state,
        general: {
          ...state.general,
          ubicacion: payload
        }
      };
    case "general.ubicacion.prop":
      return {
        ...state,
        general: {
          ...state.general,
          ubicacion: { ...state.general.ubicacion, [payload.prop]: payload.value }
        }
      };
    case "general.bancarios":
      return {
        ...state,
        general: {
          ...state.general,
          bancarios: payload
        }
      };
    case "general.bancarios.prop":
      return {
        ...state,
        general: {
          ...state.general,
          bancarios: { ...state.general.bancarios, [payload.prop]: payload.value }
        }
      };
    default:
      return { ...state };
  }
};

const PerfilTiendaDetails = () => {
  const classes = useStyles();
  const { cliente, onClienteChange } = useContext(AppContext);
  const { mobile } = useContext(MobileContext);
  const [fetchingStore, setFetchingStore] = useState(true);
  const [store, setStore] = useState(defaultStore);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [tab, setTab] = useState(tabs.general.value);
  const [sending, setSending] = useState({
    infoGeneral: false,
    infoContact: false,
    infoLocation: false,
    infoBank: false,
    deliveryHome: false,
    deliveryConvenience: false,
    deliveryPickup: false,
    paymentTransfer: false,
    addService: false,
    updateService: false,
    deliveryConvenienceText: false,
    deliveryPickupText: false
  });

  const [editingInfo, setEditingInfo] = useState({
    infoGeneral: false,
    infoContact: false,
    infoLocation: false,
    infoBank: false
  });

  const [enableTransferencia, setEnableTransferencia] = useState(false);
  const [deliveryOptions, setDeliveryOptions] = useState({
    deliveryHome: false,
    deliveryConvenience: false,
    deliveryPickup: false
  });
  const [newService, setNewService] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [deliveryServices, setDeliveryServices] = useState([]);
  const [convenienceText, setConvenienceText] = useState("");
  const [pickupText, setPickupText] = useState("");

  const [validServiceName, setValidServiceName] = useState({ valid: true, msg: "" });

  useEffect(() => {
    if (cliente) {
      fetchStore(
        cliente.id_cliente,
        () => setFetchingStore(true),
        () => setFetchingStore(false),
        setStore
      );
    }
  }, [cliente]);

  useEffect(() => {
    if (store.id) {
      const general = {
        general: {
          name: store.name,
          slug: store.slug,
          description: store.body.description
        },
        contacto: {
          email: store.body.config.email,
          phone: store.body.config.phone || cliente.body_cliente.telefono,
          whatsapp: Boolean(store.body.config.whatsapp)
        },
        ubicacion: {
          address: JSON.parse(JSON.stringify(store.body.locations[0].address))
        },
        bancarios: JSON.parse(
          JSON.stringify(store.body.config.recaudacion || cliente.body_cliente.recaudacion)
        )
      };

      dispatch({ type: "general", payload: general });
    }
  }, [store, cliente]);

  useEffect(() => {
    store.body.config.paymentOptions &&
      setEnableTransferencia(
        store.body.config.paymentOptions.includes(PAYMENT_OPTIONS.transferencia.int)
      );
  }, [store.body.config.paymentOptions]);

  useEffect(() => {
    store.body.config.deliveryOptions && setDeliveryOptions(store.body.config.deliveryOptions);
  }, [store.body.config.deliveryOptions]);

  useEffect(() => {
    store.body.config.deliveryServices && setDeliveryServices(store.body.config.deliveryServices);
  }, [store.body.config.deliveryServices]);

  useEffect(() => {
    store.body.config.deliveryConvenienceText &&
      setConvenienceText(store.body.config.deliveryConvenienceText);
  }, [store.body.config.deliveryConvenienceText]);

  useEffect(() => {
    store.body.config.deliveryPickupText && setPickupText(store.body.config.deliveryPickupText);
  }, [store.body.config.deliveryPickupText]);

  const actualizarStore = async params => {
    try {
      const vars = {
        input: {
          id: store.id,
          ...params
        }
      };

      const result = await API.graphql(graphqlOperation(updateStore, vars));

      if (result.data.updateStore) {
        const body = JSON.parse(result.data.updateStore.body);
        const store = {
          ...result.data.updateStore,
          body
        };

        setStore(store);
      }
    } catch (err) {
      logger("PerfilTiendaDetails.actualizarStore.error", params);
    }
  };

  const validarTienda = async () => {
    let valid = true;
    let msg = "";

    const rgx = new RegExp(/^[a-zA-Z' áéíóúÁÉÍÓÚ-]+$/);

    if (state.general.general.name.trim() === "") {
      valid = false;
      msg = "El nombre de la tienda es obligatorio";
    } else if (state.general.general.name.length < 3) {
      valid = false;
      msg = "El nombre de la tienda debe tener más de 3 caracteres";
    } else if (!rgx.test(state.general.general.name)) {
      valid = false;
      msg = "El nombre de la tienda debe contener solo caracteres alfanuméricos";
    }

    if (valid) {
      if (state.general.general.slug !== store.slug) {
        const available = await checkSlugName(state.general.general.slug);

        if (!available) {
          valid = false;
          msg = "Prueba otro nombre, este ya está en uso";
        }
      }
    }

    dispatch({
      type: "general.general.prop",
      payload: {
        prop: "nameError",
        value: msg
      }
    });

    return valid;
  };

  const validarCelular = () => {
    let result = true;
    let msg = "";

    if (state.general.contacto.phone.trim() === "") {
      result = false;
      msg = "El teléfono móvil es obligatorio";
    } else if (state.general.contacto.phone.length !== 8) {
      result = false;
      msg = "El teléfono móvil es inválido";
    }

    dispatch({
      type: "general.contacto.prop",
      payload: {
        prop: "phoneError",
        value: msg
      }
    });

    return result;
  };

  const validarEmail = () => {
    let result = true;
    let msg = "";

    if (state.general.contacto.email.trim() === "") {
      result = false;
      msg = "El email es obligatorio";
    } else if (!validateEmail(state.general.contacto.email)) {
      result = false;
      msg = "El email es inválido";
    }

    dispatch({
      type: "general.contacto.prop",
      payload: {
        prop: "emailError",
        value: msg
      }
    });

    return result;
  };

  const validarDireccion = () => {
    let result = true;
    let msg = "";

    if (!Boolean(state.general.ubicacion.address)) {
      result = false;
      msg = "La dirección es obligatoria";
    }

    dispatch({
      type: "general.ubicacion.prop",
      payload: {
        prop: "addressError",
        value: msg
      }
    });

    return result;
  };

  const validarTitular = () => {
    let result = true;
    let msg = "";

    if (state.general.bancarios.titular.trim() === "") {
      result = false;
      msg = "El nombre del titular es obligatorio";
    } else if (!nombreEsValido(state.general.bancarios.titular.trim())) {
      result = false;
      msg = "El nombre de titular tiene caracteres no permitidos";
    }

    dispatch({
      type: "general.bancarios.prop",
      payload: {
        prop: "titularError",
        value: msg
      }
    });

    return result;
  };

  const validarRut = () => {
    let result = true;
    let msg = "";

    if (state.general.bancarios.rut.trim() === "") {
      result = false;
      msg = "El rut es obligatorio";
    } else if (!rutEsValido(state.general.bancarios.rut)) {
      result = false;
      msg = "Rut inválido";
    }

    dispatch({
      type: "general.bancarios.prop",
      payload: {
        prop: "rutError",
        value: msg
      }
    });

    return result;
  };

  const validarBanco = () => {
    let result = true;
    let msg = "";

    if (!Boolean(state.general.bancarios.banco)) {
      result = false;
      msg = "El banco es obligatorio";
    }

    dispatch({
      type: "general.bancarios.prop",
      payload: {
        prop: "bancoError",
        value: msg
      }
    });

    return result;
  };

  const validarTipoCuenta = () => {
    let result = true;
    let msg = "";

    if (!Boolean(state.general.bancarios.tipoCuenta)) {
      result = false;
      msg = "El tipo de cuenta es obligatorio";
    }

    dispatch({
      type: "general.bancarios.prop",
      payload: {
        prop: "tipoCuentaError",
        value: msg
      }
    });

    return result;
  };

  const validarCuenta = () => {
    let result = true;
    let msg = "";

    if (state.general.bancarios.cuenta.trim() === "") {
      result = false;
      msg = "El número de cuenta es obligatorio";
    } else if (formatCuentaBancaria(state.general.bancarios.cuenta) === "00000000") {
      result = false;
      msg = "El número de cuenta es inválido";
    }

    dispatch({
      type: "general.bancarios.prop",
      payload: {
        prop: "cuentaError",
        value: msg
      }
    });

    return result;
  };

  const handleEditInfo = name => {
    setEditingInfo({ ...editingInfo, [name]: true });
  };

  const handleSaveInfo = async name => {
    setSending({ ...sending, [name]: true });

    const body = { id: store.id };

    switch (name) {
      case "infoGeneral":
        body.general = {
          name: state.general.general.name,
          slug: state.general.general.slug,
          description: state.general.general.description
        };
        break;

      case "infoContact":
        body.contacto = {
          email: state.general.contacto.email,
          phone: state.general.contacto.phone,
          whatsapp: state.general.contacto.whatsapp ? `569${state.general.contacto.phone}` : null
        };
        break;
      case "infoLocation":
        body.ubicacion = {
          address: state.general.ubicacion.address
        };
        break;
      case "infoBank":
        body.general = {
          name: state.general.general.name,
          slug: state.general.general.slug
        };
        body.bancarios = {
          titular: state.general.bancarios.titular,
          rut: state.general.bancarios.rut,
          cuenta: state.general.bancarios.cuenta,
          banco: state.general.bancarios.banco,
          tipoCuenta: state.general.bancarios.tipoCuenta
        };
        break;
      default:
        break;
    }

    try {
      const result = await API.put(process.env.REACT_APP_HUB_API, "/tienda", { body });

      if (result.success) {
        setStore(result.store);
        onClienteChange(result.cliente);
      }
    } catch (err) {
      logger("PerfilTiendaDetails.saveInfo.error", err);
    } finally {
      setSending({ ...sending, [name]: false });
    }
  };

  const toggleTransferencia = async checked => {
    setSending({ ...sending, paymentTransfer: true });

    try {
      const init = {
        body: {
          id: store.id,
          opciones: checked ? [PAYMENT_OPTIONS.transferencia.int] : []
        }
      };

      const result = await API.put(process.env.REACT_APP_HUB_API, "/tienda/medios-pago", init);

      if (result.success) {
        setStore(result.store);
      }
    } catch (err) {
      logger("PerfilTiendaDetails.toggleTransferencia.error", checked);
    } finally {
      setSending({ ...sending, paymentTransfer: false });
    }
  };

  const handleDeliverySwitch = async ({ name, checked }) => {
    setSending({ ...sending, [name]: true });

    if (!checked) {
      setSelectedService(null);
    }

    await actualizarStore({
      body: JSON.stringify({
        ...store.body,
        config: {
          ...store.body.config,
          deliveryOptions: { ...deliveryOptions, [name]: checked }
        }
      })
    });

    setSending({ ...sending, [name]: false });
  };

  const validateServiceName = () => {
    let valid = true;
    let msg = "";

    if (newService.length < 3) {
      valid = false;
      msg = "El nombre no puede ser menos de 3 caracteres";
    }

    return { valid, msg };
  };

  const addService = async () => {
    const validServiceName = validateServiceName();

    if (validServiceName.valid) {
      setSending({ ...sending, addService: true });

      const service = { name: newService.trim(), comunas: [], fee: -1, conditions: "" };
      const updatedServices = [...deliveryServices, service];

      await actualizarStore({
        body: JSON.stringify({
          ...store.body,
          config: {
            ...store.body.config,
            deliveryServices: updatedServices
          }
        })
      });

      setNewService("");
      setSending({ ...sending, addService: false });
    } else setValidServiceName(validServiceName);
  };

  const saveService = async (name, comunas, fee, conditions) => {
    setSending({ ...sending, updateService: true });

    const service = { name, comunas, fee, conditions };
    const updatedServices = deliveryServices.map(item => {
      if (item === selectedService) return service;
      return item;
    });

    await actualizarStore({
      body: JSON.stringify({
        ...store.body,
        config: {
          ...store.body.config,
          deliveryServices: updatedServices
        }
      })
    });

    setSelectedService(null);
    setSending({ ...sending, updateService: false });
  };

  const deleteService = async service => {
    setSending({ ...sending, updateService: true });
    const updatedServices = deliveryServices.filter(item => service.name !== item.name);

    await actualizarStore({
      body: JSON.stringify({
        ...store.body,
        config: {
          ...store.body.config,
          deliveryServices: updatedServices
        }
      })
    });

    setSelectedService(null);
    setSending({ ...sending, updateService: false });
  };

  const updateDeliveryText = async (name, text) => {
    setSending({ ...sending, [name]: true });

    await actualizarStore({
      body: JSON.stringify({
        ...store.body,
        config: {
          ...store.body.config,
          [name]: text
        }
      })
    });

    setSelectedService(null);
    setSending({ ...sending, [name]: false });
  };

  const cancelInfoGeneralEdit = () => {
    const payload = {
      name: store.name,
      slug: store.slug,
      description: store.body.description
    };

    dispatch({ type: "general.general", payload });

    setEditingInfo({ ...editingInfo, infoGeneral: false });
  };

  const cancelInfoContactEdit = () => {
    const payload = {
      email: store.body.config.email,
      phone: store.body.config.phone || cliente.body_cliente.telefono,
      whatsapp: Boolean(store.body.config.whatsapp)
    };

    dispatch({ type: "general.contacto", payload });

    setEditingInfo({ ...editingInfo, infoContact: false });
  };

  const cancelInfoLocationEdit = () => {
    const payload = {
      address: JSON.parse(JSON.stringify(store.body.locations[0].address))
    };

    dispatch({ type: "general.ubicacion", payload });

    setEditingInfo({ ...editingInfo, infoLocation: false });
  };

  const cancelInfoBankEdit = () => {
    const payload = JSON.parse(
      JSON.stringify(store.body.config.recaudacion || cliente.body_cliente.recaudacion)
    );

    dispatch({ type: "general.bancarios", payload });

    setEditingInfo({ ...editingInfo, infoBank: false });
  };

  const renderGeneral = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>
              {editingInfo.infoGeneral ? renderInfoGeneralEdit() : renderInfoGeneral()}
            </CardContent>
            {editingInfo.infoGeneral && (
              <CardActions>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  onClick={cancelInfoGeneralEdit}
                >
                  Cancelar
                </Button>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  disabled={
                    Boolean(state.general.general.nameError) ||
                    Boolean(state.general.general.descriptionError)
                  }
                  onClick={() => handleSaveInfo("infoGeneral")}
                >
                  Guardar
                </Button>
              </CardActions>
            )}
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card className={classes.card}>
            <CardContent>
              {editingInfo.infoContact ? renderInfoContactEdit() : renderInfoContact()}
            </CardContent>
            {editingInfo.infoContact && (
              <CardActions>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  onClick={cancelInfoContactEdit}
                >
                  Cancelar
                </Button>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  disabled={
                    Boolean(state.general.contacto.phoneError) ||
                    Boolean(state.general.contacto.emailError)
                  }
                  onClick={() => handleSaveInfo("infoContact")}
                >
                  Guardar
                </Button>
              </CardActions>
            )}
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card className={classes.card}>
            <CardContent>
              {editingInfo.infoLocation ? renderInfoLocationEdit() : renderInfoLocation()}
            </CardContent>
            {editingInfo.infoLocation && (
              <CardActions>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  onClick={cancelInfoLocationEdit}
                >
                  Cancelar
                </Button>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  disabled={Boolean(state.general.ubicacion.addressError)}
                  onClick={() => handleSaveInfo("infoLocation")}
                >
                  Guardar
                </Button>
              </CardActions>
            )}
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>
              {editingInfo.infoBank ? renderInfoBankEdit() : renderInfoBank()}
            </CardContent>
            {editingInfo.infoBank && (
              <CardActions>
                <Button className={classes.saveButton} color="primary" onClick={cancelInfoBankEdit}>
                  Cancelar
                </Button>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  disabled={
                    Boolean(state.general.bancarios.titularError) ||
                    Boolean(state.general.bancarios.rutError) ||
                    Boolean(state.general.bancarios.bancoError) ||
                    Boolean(state.general.bancarios.tipoCuentaError) ||
                    Boolean(state.general.bancarios.cuentaError)
                  }
                  onClick={() => handleSaveInfo("infoBank")}
                >
                  Guardar
                </Button>
              </CardActions>
            )}
          </Card>
        </Grid>
      </Grid>
    );
  };

  const renderInfoGeneral = () => {
    return (
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={6} container spacing={1} alignItems="center">
          <Grid item xs={2} sm={1}>
            <InfoIcon className={classes.titleIcons} />
          </Grid>
          <Grid item xs={10} sm={11} container spacing={2} alignItems="center" wrap="nowrap">
            <Grid item>
              <Typography variant={mobile ? "body1" : "h6"}>General</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={e => handleEditInfo("infoGeneral")}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>

          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant={mobile ? "body2" : "body1"}>{store.name}</Typography>
          </Grid>

          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            {store.body.description ? (
              <Typography variant={mobile ? "body2" : "body1"} color="textSecondary">
                {store.body.description}
              </Typography>
            ) : (
              <Alert severity="info">
                <AlertTitle>Aún no ingresas la descripción de tu tienda</AlertTitle>
                Presiona el botón editar y cuéntanos sobre tu tienda.
              </Alert>
            )}
          </Grid>

          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant="caption" color="textSecondary">
              Creado el{" "}
              {format(parseJSON(store.createdAt), "dd MMM, p", {
                locale: es
              })}
              <br />
              Plan {PLANES.get(cliente.body_cliente.plan).label}
            </Typography>
          </Grid>
        </Grid>
        <Hidden smDown>
          <Grid item sm={6} container justify="flex-end">
            <Grid item sm={7}>
              <Typography variant={mobile ? "body2" : "body1"} color="textSecondary">
                El nombre y descripción son importantes. Así te reconocerán tus clientes
              </Typography>
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    );
  };

  const renderInfoGeneralEdit = () => {
    return (
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={2} sm={1}>
          <InfoIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={10} sm={11}>
          <Typography variant={mobile ? "body1" : "h6"}>General</Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            size="small"
            fullWidth
            label="Nombre"
            inputProps={{ maxLength: 45 }}
            disabled={sending.infoGeneral}
            value={state.general.general.name}
            onChange={({ target }) =>
              dispatch({ type: "general.general.name", payload: target.value })
            }
            onBlur={validarTienda}
            error={Boolean(state.general.general.nameError)}
            helperText={state.general.general.nameError}
          />
          <Typography component="div" variant="caption" color="textSecondary">
            Ten en cuenta que al cambiar el nombre de tu tienda todos los enlaces que se hayan
            generado quedarán obsoletos.
          </Typography>

          {state.general.general.slug !== store.slug && !Boolean(state.general.general.nameError) && (
            <Typography component="div" className="mt-2" variant="body2" color="textSecondary">
              El link que ocuparán tus clientes se verá así
              <div className="ml-3">https://app.carritofacil.cl/{state.general.general.slug}</div>
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} />
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            size="small"
            label="Descripción"
            value={state.general.general.description}
            onChange={({ target }) =>
              dispatch({
                type: "general.general.prop",
                payload: { prop: "description", value: target.value }
              })
            }
            disabled={sending.infoGeneral}
          />
        </Grid>
      </Grid>
    );
  };

  const renderInfoContact = () => {
    return (
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={2} sm={1}>
          <AlternateEmailIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={10} sm={11} container spacing={1} alignItems="center" wrap="nowrap">
          <Grid item>
            <Typography variant={mobile ? "body1" : "h6"}>Contacto</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={e => handleEditInfo("infoContact")}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>

        <Grid item xs={2} sm={1} />
        <Grid item xs={10} sm={11}>
          <Typography component="div" variant={mobile ? "body2" : "body1"}>
            {formatCelular(cliente.body_cliente.telefono)}
          </Typography>
          <Typography component="div" variant="caption" color="textSecondary">
            {store.body.config.whatsapp
              ? "Contacto por WhatsApp habilitado"
              : "Contacto por WhatsApp deshabilitado"}
          </Typography>
        </Grid>

        <Grid item xs={2} sm={1} />
        <Grid item xs={10} sm={11}>
          <Typography variant={mobile ? "body2" : "body1"}>{store.body.config.email}</Typography>
        </Grid>
      </Grid>
    );
  };

  const renderInfoContactEdit = () => {
    return (
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={2} sm={1}>
          <AlternateEmailIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={10} sm={11}>
          <Typography variant={mobile ? "body1" : "h6"}>Contacto</Typography>
        </Grid>

        <Grid item xs={12} container alignItems="center">
          <Grid item xs={12} md={4}>
            <NumberFormat
              customInput={TextField}
              required
              fullWidth
              format="+56 9 #### ####"
              allowEmptyFormatting
              type="tel"
              label="Teléfono"
              disabled={sending.infoContact}
              value={state.general.contacto.phone}
              onValueChange={({ value }) =>
                dispatch({ type: "general.contacto.prop", payload: { prop: "phone", value } })
              }
              onBlur={validarCelular}
              error={Boolean(state.general.contacto.phoneError)}
              helperText={state.general.contacto.phoneError}
            />
          </Grid>
          <Grid item xs={12} md={8} container justify="center">
            <FormControlLabel
              className={classes.whatsappForm}
              control={
                <Checkbox
                  disabled={sending.infoContact}
                  checked={state.general.contacto.whatsapp}
                  onChange={({ target }) =>
                    dispatch({
                      type: "general.contacto.prop",
                      payload: { prop: "whatsapp", value: target.checked }
                    })
                  }
                  color="primary"
                />
              }
              label={<Typography variant="body2">Habilitar contacto por WhatsApp</Typography>}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            size="small"
            fullWidth
            label="Email"
            type="email"
            inputProps={{ maxLength: 50 }}
            disabled={sending.infoContact}
            value={state.general.contacto.email}
            onChange={({ target }) =>
              dispatch({
                type: "general.contacto.prop",
                payload: { prop: "email", value: target.value.toLowerCase() }
              })
            }
            onBlur={validarEmail}
            error={Boolean(state.general.contacto.emailError)}
            helperText={state.general.contacto.emailError}
          />
        </Grid>
      </Grid>
    );
  };

  const renderInfoLocation = () => {
    return (
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={2} sm={1}>
          <MapIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={10} sm={11} container spacing={1} alignItems="center" wrap="nowrap">
          <Grid item>
            <Typography variant={mobile ? "body1" : "h6"}>Ubicación</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={e => handleEditInfo("infoLocation")}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>

        <Grid item xs={2} sm={1} />
        <Grid item xs={10} sm={11}>
          <Typography variant={mobile ? "body2" : "body1"}>
            {store.body.locations[0].address.description}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderInfoLocationEdit = () => {
    return (
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={2} sm={1}>
          <MapIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={10} sm={11}>
          <Typography variant={mobile ? "body1" : "h6"}>Ubicación</Typography>
        </Grid>

        <Grid item xs={12}>
          <SelectAddress
            required
            label="Dirección"
            disabled={sending.infoLocation}
            value={state.general.ubicacion.address}
            onChange={place =>
              dispatch({
                type: "general.ubicacion.prop",
                payload: { prop: "address", value: place }
              })
            }
            onBlur={validarDireccion}
            error={Boolean(state.general.ubicacion.addressError)}
            helperText={state.general.ubicacion.addressError}
          />
        </Grid>
      </Grid>
    );
  };

  const renderInfoBank = () => {
    return (
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={6} container spacing={1} alignItems="center">
          <Grid item xs={2} sm={1}>
            <AccountBalanceIcon className={classes.titleIcons} />
          </Grid>
          <Grid item xs={10} sm={11} container spacing={1} alignItems="center" wrap="nowrap">
            <Grid item>
              <Typography variant={mobile ? "body1" : "h6"}>Cuenta bancaria</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={e => handleEditInfo("infoBank")}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>

          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant={mobile ? "body2" : "body1"}>
              {cliente.body_cliente.recaudacion.titular}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant={mobile ? "body2" : "body1"}>
              {formatRut(cliente.body_cliente.recaudacion.rut)}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant={mobile ? "body2" : "body1"}>
              {cliente.body_cliente.recaudacion.banco.label}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant={mobile ? "body2" : "body1"}>
              {cliente.body_cliente.recaudacion.tipoCuenta.label}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={1} />
          <Grid item xs={10} sm={11}>
            <Typography variant={mobile ? "body2" : "body1"}>
              {cliente.body_cliente.recaudacion.cuenta}
            </Typography>
          </Grid>
        </Grid>
        <Hidden smDown>
          <Grid item sm={6} container justify="flex-end">
            <Grid item sm={7}>
              <Typography variant={mobile ? "body2" : "body1"}>
                ¡La información bancaria es muy importante!. Asegúrate que el nombre del titular
                esté bien ingresado.
              </Typography>
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    );
  };

  const renderInfoBankEdit = () => {
    return (
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={2} sm={1}>
          <AccountBalanceIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={10} sm={11}>
          <Typography variant={mobile ? "body1" : "h6"}>Cuenta bancaria</Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            size="small"
            fullWidth
            label="Titular"
            inputProps={{ maxLength: 50 }}
            disabled={sending.infoBank}
            value={state.general.bancarios.titular}
            onChange={({ target }) =>
              dispatch({
                type: "general.bancarios.prop",
                payload: { prop: "titular", value: toTitleCase(target.value) }
              })
            }
            onBlur={validarTitular}
            error={Boolean(state.general.bancarios.titularError)}
            helperText={state.general.bancarios.titularError}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            required
            size="small"
            fullWidth
            label="Rut"
            inputProps={{ maxLength: 12 }}
            disabled={sending.infoBank}
            value={formatRut(state.general.bancarios.rut)}
            onChange={({ target }) =>
              dispatch({
                type: "general.bancarios.prop",
                payload: { prop: "rut", value: unformatRut(target.value) }
              })
            }
            onBlur={validarRut}
            error={Boolean(state.general.bancarios.rutError)}
            helperText={state.general.bancarios.rutError}
          />
        </Grid>

        <Grid item xs={12}>
          <SelectBanco
            required
            variant="standard"
            disabled={sending.infoBank}
            value={state.general.bancarios.banco}
            onChange={value =>
              dispatch({
                type: "general.bancarios.prop",
                payload: { prop: "banco", value }
              })
            }
            onBlur={validarBanco}
            error={Boolean(state.general.bancarios.bancoError)}
            helperText={state.general.bancarios.bancoError}
          />
        </Grid>

        <Grid item xs={12}>
          <SelectTipoCuenta
            required
            variant="standard"
            disabled={sending.infoBank}
            value={state.general.bancarios.tipoCuenta}
            onChange={value =>
              dispatch({
                type: "general.bancarios.prop",
                payload: { prop: "tipoCuenta", value }
              })
            }
            onBlur={validarTipoCuenta}
            error={Boolean(state.general.bancarios.tipoCuentaError)}
            helperText={state.general.bancarios.tipoCuentaError}
          />
        </Grid>

        <Grid item xs={12}>
          <NumberFormat
            customInput={TextField}
            required
            fullWidth
            label="Número de cuenta"
            disabled={sending.infoBank}
            value={state.general.bancarios.cuenta}
            onValueChange={({ value }) =>
              dispatch({
                type: "general.bancarios.prop",
                payload: { prop: "cuenta", value: formatCuentaBancaria(value) }
              })
            }
            onBlur={validarCuenta}
            error={Boolean(state.general.bancarios.cuentaError)}
            helperText={state.general.bancarios.cuentaError}
          />
        </Grid>
      </Grid>
    );
  };

  const renderTiposEntrega = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>{renderDeliveryHome()}</CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>{renderDeliveryConvenience()}</CardContent>

            {deliveryOptions.deliveryConvenience &&
              store.body.config.deliveryConvenienceText !== convenienceText && (
                <CardActions>
                  <Button
                    className={classes.saveButton}
                    color="primary"
                    onClick={() =>
                      convenienceText.trim().length > 4 &&
                      updateDeliveryText("deliveryConvenienceText", convenienceText)
                    }
                  >
                    Guardar
                  </Button>
                </CardActions>
              )}
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>{renderDeliveryPickup()}</CardContent>

            {deliveryOptions.deliveryPickup && store.body.config.deliveryPickupText !== pickupText && (
              <CardActions>
                <Button
                  className={classes.saveButton}
                  color="primary"
                  onClick={() =>
                    pickupText.trim().length > 4 &&
                    updateDeliveryText("deliveryPickupText", pickupText)
                  }
                >
                  Guardar
                </Button>
              </CardActions>
            )}
          </Card>
        </Grid>
        {!deliveryOptions.deliveryHome &&
          !deliveryOptions.deliveryConvenience &&
          !deliveryOptions.deliveryPickup && (
            <Grid item xs={12}>
              <Alert severity="warning">
                <strong>Atención:</strong> Te recomendamos tener, al menos, una entrega activa.
              </Alert>
            </Grid>
          )}
      </Grid>
    );
  };

  const renderDeliveryHome = () => {
    return (
      <Grid container justify="center" alignItems="center" spacing={2}>
        <Grid item xs={2}>
          <LocalShippingIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={7}>
          <Typography variant={mobile ? "body1" : "h6"}>Entrega a domicilio</Typography>
        </Grid>
        <Grid item xs={2} container justify="flex-end">
          {sending.deliveryHome ? (
            <CircularProgress className={classes.loading} size="1.25rem" />
          ) : (
            <Switch
              checked={deliveryOptions.deliveryHome}
              onChange={({ target }) => handleDeliverySwitch(target)}
              color="primary"
              name="deliveryHome"
              disabled={
                sending.addService ||
                sending.deliveryHome ||
                sending.deliveryConvenience ||
                sending.deliveryPickup ||
                sending.deliveryConvenienceText ||
                sending.deliveryPickupText
              }
            />
          )}
        </Grid>
        {deliveryOptions.deliveryHome && (
          <>
            <Grid item xs={11}>
              <Typography className={classes.bold} variant={mobile ? "body2" : "body1"}>
                Servicios de despacho
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                size="small"
                fullWidth
                label="Nombre del servicio"
                placeholder="Ej: Despacho Santiago Oriente"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ maxLength: 100 }}
                value={newService}
                onChange={({ target }) => setNewService(target.value)}
                onBlur={() => setValidServiceName(validateServiceName())}
                error={!validServiceName.valid}
                helperText={!validServiceName.valid && validServiceName.msg}
                disabled={
                  sending.addService ||
                  sending.deliveryHome ||
                  sending.deliveryConvenience ||
                  sending.deliveryPickup ||
                  sending.deliveryConvenienceText ||
                  sending.deliveryPickupText
                }
              />
            </Grid>
            <Grid item xs={2} container justify="flex-end">
              {sending.addService ? (
                <CircularProgress className={classes.loading} size="1.25rem" />
              ) : (
                <IconButton
                  className="p-0"
                  onClick={addService}
                  disabled={
                    sending.addService ||
                    sending.deliveryHome ||
                    sending.deliveryConvenience ||
                    sending.deliveryPickup ||
                    sending.deliveryConvenienceText ||
                    sending.deliveryPickupText
                  }
                >
                  <AddCircleIcon
                    className={classes.addIcon}
                    style={
                      sending.addService ||
                      sending.deliveryHome ||
                      sending.deliveryConvenience ||
                      sending.deliveryPickup ||
                      sending.deliveryConvenienceText ||
                      sending.deliveryPickupText
                        ? { color: "gray" }
                        : { color: "#FF8F1C" }
                    }
                  />
                </IconButton>
              )}
            </Grid>
            {deliveryServices && deliveryServices.length > 0 && (
              <Grid item xs={11}>
                <List className={classes.deliveryServicesList} disablePadding>
                  {deliveryServices.map((service, i) => (
                    <ListItem
                      key={`deliveyr-${i}`}
                      className={classes.deliveryServiceItem}
                      button
                      divider
                      onClick={() => setSelectedService(service)}
                    >
                      <ListItemText primary={service.name} />
                      <ListItemSecondaryAction>
                        <ArrowForwardIosIcon fontSize="small" />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            )}
          </>
        )}
      </Grid>
    );
  };

  const renderDeliveryConvenience = () => {
    return (
      <Grid container justify="center" alignItems="center" spacing={2}>
        <Grid item xs={2}>
          <ForumIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={7}>
          <Typography variant={mobile ? "body1" : "h6"}>Entrega a convenir</Typography>
        </Grid>
        <Grid item xs={2} container justify="flex-end">
          {sending.deliveryConvenience || sending.deliveryConvenienceText ? (
            <CircularProgress className={classes.loading} size="1.25rem" />
          ) : (
            <Switch
              checked={deliveryOptions.deliveryConvenience}
              onChange={({ target }) => handleDeliverySwitch(target)}
              color="primary"
              name="deliveryConvenience"
              disabled={
                sending.addService ||
                sending.deliveryHome ||
                sending.deliveryConvenience ||
                sending.deliveryPickup ||
                sending.deliveryConvenienceText ||
                sending.deliveryPickupText
              }
            />
          )}
        </Grid>
        {deliveryOptions.deliveryConvenience && (
          <Grid item xs={11}>
            <TextField
              className="mb-3"
              size="small"
              fullWidth
              multiline
              required
              rows={4}
              label="Términos y condiciones de entrega"
              placeholder="Ej: Hacemos envíos a todo Chile vía Chilexpress por cobrar"
              InputLabelProps={{
                shrink: true
              }}
              value={convenienceText}
              inputProps={{ maxLength: 500 }}
              onChange={({ target }) => setConvenienceText(target.value)}
              disabled={
                sending.addService ||
                sending.deliveryHome ||
                sending.deliveryConvenience ||
                sending.deliveryPickup ||
                sending.deliveryConvenienceText ||
                sending.deliveryPickupText
              }
              error={convenienceText.trim().length <= 4}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const renderDeliveryPickup = () => {
    return (
      <Grid container justify="center" alignItems="center" spacing={2}>
        <Grid item xs={2}>
          <StoreIcon className={classes.titleIcons} />
        </Grid>
        <Grid item xs={7}>
          <Typography variant={mobile ? "body1" : "h6"}>Retiro en tienda</Typography>
        </Grid>
        <Grid item xs={2} container justify="flex-end">
          {sending.deliveryPickup || sending.deliveryPickupText ? (
            <CircularProgress className={classes.loading} size="1.25rem" />
          ) : (
            <Switch
              checked={deliveryOptions.deliveryPickup}
              onChange={({ target }) => handleDeliverySwitch(target)}
              color="primary"
              name="deliveryPickup"
              disabled={
                sending.addService ||
                sending.deliveryHome ||
                sending.deliveryConvenience ||
                sending.deliveryPickup ||
                sending.deliveryConvenienceText ||
                sending.deliveryPickupText
              }
            />
          )}
        </Grid>
        {deliveryOptions.deliveryPickup && (
          <Grid item xs={11}>
            <TextField
              className="mb-3"
              size="small"
              fullWidth
              multiline
              required
              rows={4}
              label="Términos y condiciones de entrega"
              placeholder="Ej: Dirígete a nuestra tienda de Lunes a Viernes entre 10 y 18 hrs, ubicada en Santa Isabel 365"
              InputLabelProps={{
                shrink: true
              }}
              value={pickupText}
              inputProps={{ maxLength: 500 }}
              onChange={({ target }) => setPickupText(target.value)}
              disabled={
                sending.addService ||
                sending.deliveryHome ||
                sending.deliveryConvenience ||
                sending.deliveryPickup ||
                sending.deliveryConvenienceText ||
                sending.deliveryPickupText
              }
              error={pickupText.trim().length <= 4}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const renderMediosPago = () => {
    return (
      <Card className={classes.card}>
        <CardHeader title="Medios de pago" />
        <CardContent>
          <div className="ml-4">
            <FormControlLabel
              control={
                sending.paymentTransfer ? (
                  <CircularProgress className={classes.loading} size="1.25rem" />
                ) : (
                  <Checkbox
                    disabled={sending.paymentTransfer}
                    checked={enableTransferencia}
                    onChange={({ target }) => toggleTransferencia(target.checked)}
                    color="primary"
                  />
                )
              }
              label={
                <Typography variant="body1">Habilitar pago con transferencia bancaria</Typography>
              }
            />
          </div>
        </CardContent>
      </Card>
    );
  };

  const renderComunidades = () => (
    <Card className={classes.card}>
      <CardHeader title="Proximamente" />
      <CardContent>
        <Typography align="center" variant={"h6"}>
          Estamos construyendo algo nuevo para ti...
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <>
      {fetchingStore ? (
        <div className={classes.loadingContainer}>
          <CircularProgress className={classes.loading} size="2.5rem" />
        </div>
      ) : (
        <>
          <AppBar className={classes.tabbar} position="sticky" elevation={0}>
            <Tabs
              variant={mobile ? "scrollable" : "standard"}
              centered={false}
              value={tab}
              onChange={(_, newValue) => setTab(newValue)}
            >
              <Tab label={tabs.general.label} />
              <Tab label={tabs.tiposEntrega.label} />
              <Tab label={tabs.mediosPago.label} />
              <Tab label={tabs.comunidades.label} />
              <Tab label={tabs.faq.label} />
            </Tabs>
          </AppBar>

          <TabPanel className={classes.tabpanel} index={tabs.general.value} tab={tab}>
            <Container className={classes.container} maxWidth={"md"}>
              {renderGeneral()}
            </Container>
          </TabPanel>

          <TabPanel className={classes.tabpanel} index={tabs.tiposEntrega.value} tab={tab}>
            <Container className={classes.container} maxWidth={"lg"}>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  {renderTiposEntrega()}
                </Grid>
                <Grid item sm={12} md={6}>
                  <DeliveryServiceDetails
                    service={selectedService}
                    loading={sending.updateService}
                    onDelete={deleteService}
                    onSave={saveService}
                    onClose={() => setSelectedService(null)}
                  />
                </Grid>
              </Grid>
            </Container>
          </TabPanel>

          <TabPanel className={classes.tabpanel} index={tabs.mediosPago.value} tab={tab}>
            <Container className={classes.container} maxWidth={"sm"}>
              {renderMediosPago()}
            </Container>
          </TabPanel>

          <TabPanel className={classes.tabpanel} index={tabs.comunidades.value} tab={tab}>
            <Container className={classes.container} maxWidth={"sm"}>
              {renderComunidades()}
            </Container>
          </TabPanel>

          <TabPanel className={classes.tabpanel} index={tabs.faq.value} tab={tab}>
            <Container className={classes.container} maxWidth={"sm"}>
              <FaqList storeID={store.id} productID="null" mobile={mobile} />
            </Container>
          </TabPanel>
        </>
      )}
    </>
  );
};

export default PerfilTiendaDetails;
